import { createPermissionKeys } from '@gokrew/ui/utility/createPermissionKeys';
import { Subject } from '@/types/permissions';

/**
 * Type-safe permission keys for the company portal.
 */
export const permissionKeys = createPermissionKeys(Object.values(Subject));
